/* eslint-disable react/no-children-prop */
import React, { useCallback, useEffect, useMemo, useState } from "react";

import { useFilters } from "@/providers/FiltersProvider";
import { ICommonFilter, ICommonFilterWithChildren, IMainFilterChildren } from "@/types/Filters";

import FilterAccordionItem from "./FilterAccordionItem";
import FilterSearchInput from "./FilterSearchInput";

interface INestedMultiCheckbox {
    data: IMainFilterChildren
}
function NestedMultiCheckbox({ data }: INestedMultiCheckbox) {
    const [searchText, setSearchText] = useState("");
    const { tempFilters, setTempFilters } = useFilters();
    const [selectedItem, setSelectedItem] = useState<ICommonFilter[]>([]);

    useEffect(() => {
        const f = tempFilters?.[data.id];
        if (f) {
            setSelectedItem(f);
        }
    }, [data.id, tempFilters]);

    const filterData: ICommonFilterWithChildren[] = useMemo(() => {
        if (data.data) {
            return data.data;
        }
        return [];
    }, [data.data]);

    const groupedFilterData: ICommonFilter[] = useMemo(() => {
        if (data.data) {
            const m: ICommonFilter[] = [];
            data.data.forEach((i: ICommonFilterWithChildren) => m.push(...i.children));
            return m;
        }
        return [];
    }, [data.data]);

    const handleOnChange = useCallback((item: ICommonFilter) => {
        setSelectedItem(p => {
            if (p.find(i => i.value === item.value)) {
                return p.filter((i: ICommonFilter) => i.value !== item.value);
            }
            const t = [...p, {
                label: item.label,
                value: item.value,
            }];
            setTempFilters({
                ...tempFilters,
                [data.id]: t,
            });
            return t;
        });
    }, [data.id, tempFilters, setTempFilters]);

    const getCheckbox = useCallback((currentItem: ICommonFilter[]) => {
        return currentItem.map((item) => (
            <div className='checkBoxItems'>
                <div className='checkBox'>
                    <input
                        type="checkbox"
                        id={item.label + item.value}
                        name={item.label}
                        value={item.value}
                        key={item.value}
                        checked={!!selectedItem.find(i => i.value === item.value)}
                        onChange={() => handleOnChange(item)} />
                    <label htmlFor={item.label + item.value}>{item.label}</label>
                </div>
            </div>
        ));

    }, [handleOnChange, selectedItem]);

    const groupedFilterDataBySearchText = useMemo(() => {
        return groupedFilterData.filter(i => i.label.toLowerCase().includes(searchText.toLowerCase()));
    }, [searchText, groupedFilterData]);
    return (
        <div>
            {
                data.hasSearch
                && <FilterSearchInput
                    setValue={setSearchText} />
            }
            {
                searchText.length === 0
                    ? <div className="filterRowWrap">
                        {
                            filterData.map(item => <FilterAccordionItem name={item.name} children={getCheckbox(item.children)} />)
                        }
                    </div>
                    : groupedFilterDataBySearchText.map(item => (
                        <div className="checkBoxItems" key={item.value}>
                            <div className='checkBox'>
                                <input
                                    type="checkbox"
                                    id={item.label +item.value}
                                    name={item.label}
                                    value={item.value}
                                    checked={!!selectedItem.find(i => i.value === item.value)}
                                    onChange={() => handleOnChange(item)} />
                                <label htmlFor={item.label +item.value}>{item.label}</label>
                            </div>
                        </div>
                    ))
            }
        </div>
    );
}

export default NestedMultiCheckbox;
